import {
    AgencySettings, Experiment, Role, StateShortName,
} from '@acp/shared';

export enum NavigationItemType {
    InternalLink,
    ExternalLink,
    DropdownMenu
}

export type AppNavigationItem = {
    type: NavigationItemType;
    title: string;
    to?: string;
    applicableStates: StateShortName[] | null;
    applicableRoles: Role[] | null;
    applicableExperiment?: Experiment;
    applicableAgencySettings?: (settings: AgencySettings) => boolean;
    collapse: boolean;
    dropdownItems?: DropdownMenuItem[];
};

export type DropdownMenuItem = Omit<AppNavigationItem, 'dropdownItems' | 'collapse'>;
